import React, { useState, useEffect, useCallback, useContext } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "../DataTable";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useNavigate } from "react-router-dom";
import ApiService from "app/services/config";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import HeaderBreadcrumbs from 'app/layouts/shared/headers/HeaderBreadcrumbs/HeaderBreadcrumbs';
import { PermissionContext } from "app/contexts/PermissionContext";
import { useSnackbar } from "notistack";

const Team = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [classes, setClasses] = useState([]);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState("");
  const { hasPermission } = useContext(PermissionContext);
  
  const navigate = useNavigate();
  const Swal = useSwalWrapper();

  const toast = (variant, message, type = false) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true,
      closeButtonAriaLabel: "Fechar",
      timer: 3000,
    });
  };
  const modalAlert = (id) => {
    Swal.fire({
      title: `Tem certeza que deseja excluir a turma?`,
      text: `Você perderá os dados da turma cadastrada!`,
      icon: `warning`,
      showCancelButton: true,
      confirmButtonText: `Sim!`,
      cancelButtonText: `Não!`,
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        return handleDeleteClass(id);
      }
    });
  };

  const getClasses = useCallback(async () => {
    try {
      let apiUrl = `/class?page=${
        page + 1
      }&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

      if (searchTerm) {
        apiUrl += `&searchTerm=${searchTerm}`;
      }
      ApiService.get(apiUrl)
        .then((response) => {
          console.log(response.data);

          setClasses(response.data?.turmas);
          setCount(response.data?.total);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("error", error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, [page, perPage, sortBy, sortOrder, searchTerm]);

  const handleDeleteClass = async (id) => {
    try {
      await ApiService.delete(`/class/${id}`).then((response) => {
        if (response.status === 200) {
          enqueueSnackbar("Turma excluída com sucesso!", {
            variant: "success",
            
          });
          getClasses();
        }
      });
    } catch (error) {
      enqueueSnackbar("Ocorreu um erro!", {
        variant: "error",
        
      });
      console.log(error);
    }
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "nome_turma",
      label: "Turma",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "descricao",
      label: "Descrição",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "acao",
      label: "Ação",
      options: {
        customBodyRender: (value, tableMeta) => {
          const turmaId = tableMeta.rowData[0];
          return (
            <Box display="flex" gap={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  navigate(`/team/${turmaId}`);
                }}
                disabled={!hasPermission('Turma', 'update')}
              >
                <VisibilityIcon sx={{ cursor: "pointer" }} />
              </Button>

              <Button
                variant="outlined"
                color="secondary"
                onClick={() => modalAlert(turmaId)}
                disabled={!hasPermission('Turma', 'delete')}
              >
                <DeleteIcon sx={{ cursor: "pointer" }} />
              </Button>
            </Box>
          );
        },
      },
    },
  ];

  useEffect(() => {
    getClasses();
  }, []);

  return (
    <div>
      <HeaderBreadcrumbs
          title={'Turmas'}
          titleUrl={'/Team'}
      />
      <Paper
        style={{
          padding: "10px",
          marginBottom: "15px",
          overflowX: "auto",
          overflowY: "auto",
        }}
        square={false}
        elevation={3}
      >
        {/* <Typography variant="h1" gutterBottom style={{ marginBottom: "15px" }}>
          Turmas
        </Typography> */}
        <Divider
          style={{ height: "100%", marginBottom: "20px", marginTop: "20px" }}
        />
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item textAlign={"center"} xs={12}>
            <Button
              endIcon={<GroupAddIcon />}
              variant="contained"
              to="/newTeam"
              onClick={() => {
                navigate("/newteam");
              }}
              disabled={!hasPermission('Turma', 'create')}
            >
              Nova Turma
            </Button>
          </Grid>
          <Grid item xs={12}>
            <DataTable title={"Turmas"} columns={columns} data={classes} />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default Team;
